import { render, staticRenderFns } from "./confirmPayment.vue?vue&type=template&id=c005cfb8"
import script from "./confirmPayment.vue?vue&type=script&lang=js"
export * from "./confirmPayment.vue?vue&type=script&lang=js"
import style0 from "./confirmPayment.vue?vue&type=style&index=0&id=c005cfb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports